<app-nav></app-nav>


<div class="container">
  <h1>Cancel subscription</h1>
  <h3>Sorry about that</h3>
  <p>Please confirm your choice</p>
  <p *ngIf="error" class="text-danger">
    {{error}}
  </p>
  <button class="action" (click)="onSubmit()">Submit</button>
</div>
<app-footer></app-footer>
